import { render, staticRenderFns } from "./region.vue?vue&type=template&id=a9b71e82"
import script from "./region.vue?vue&type=script&lang=js"
export * from "./region.vue?vue&type=script&lang=js"
import style0 from "./region.vue?vue&type=style&index=0&id=a9b71e82&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9b71e82')) {
      api.createRecord('a9b71e82', component.options)
    } else {
      api.reload('a9b71e82', component.options)
    }
    module.hot.accept("./region.vue?vue&type=template&id=a9b71e82", function () {
      api.rerender('a9b71e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers/fields/region.vue"
export default component.exports